/** Allowed `appMapping` values for metric definitions (empty = none). */
export const METRIC_APP_MAPPING_DRAUGHT_INSIGHTS = 'Draught_Insights';

export const METRIC_APP_MAPPING_OPTIONS = [
  { value: '', label: '(none)' },
  {
    value: METRIC_APP_MAPPING_DRAUGHT_INSIGHTS,
    label: 'Draught Insights',
  },
];

/** camelCase metric key: starts with lowercase letter, then letters/digits only. */
export const METRIC_KEY_PATTERN = /^[a-z][a-zA-Z0-9]*$/;

/**
 * @param {string} raw
 * @returns {{ ok: true, key: string } | { ok: false, message: string }}
 */
export function validateMetricKey(raw) {
  const key = (raw ?? '').trim();
  if (!key) {
    return { ok: false, message: 'Key is required.' };
  }
  if (!METRIC_KEY_PATTERN.test(key)) {
    return {
      ok: false,
      message:
        'Key must be camelCase: start with a lowercase letter, then letters or digits only (e.g. abvRange, leadingBeerStyle).',
    };
  }
  return { ok: true, key };
}
